<template>
  <div v-if="showCookieModal" class="cookie-overlay" @click.self="closeModal">
    <div class="cookie-modal">
      <div class="cookie-content">
        <h2>Hjemmesiden bruger cookies</h2>
        <p>Nogle bruges til statistik og andre sættes af tredjepartstjenester. Ved at klikke 'Accepter alle' accepterer du brugen af cookies. Du kan til enhver tid ændre eller trække dit samtykke tilbage, hvilket sker nederst på websitet.</p>
        
        <div class="cookie-links">
          <a href="#" @click.prevent="activeTab = 'about'">Om cookies</a>
          <a href="https://business.safety.google/privacy/" target="_blank">Googles privatlivspolitik</a>
          <a href="#" @click.prevent="activeTab = 'details'">Vis detaljer</a>
        </div>
        
        <div v-if="activeTab === 'about'" class="tab-content">
          <h3>7. Cookies</h3>
          <p>Dit samtykke gælder for dette domæne.</p>
          <p>Cookiedeklarationen er sidst opdateret d. 04.06.2026</p>
          
          <h4>7.1 Hvad er en cookie?</h4>
          <p>En cookie er en lille datafil, som bliver gemt på din computer, tablet eller mobiltelefon. En cookie er ikke et program, der kan indeholde skadelige programmer eller virus.</p>
          
          <h4>7.2 Hjemmesidens brug af cookies</h4>
          <p>Cookies er nødvendige for at få hjemmesiden til at fungere. Cookies hjælper os desuden med at få overblik over dit besøg på hjemmesiden, så vi løbende kan optimere og målrette hjemmesiden til dine behov og interesser. Cookies husker f.eks., hvad du har lagt i en eventuel indkøbskurv, om du tidligere har besøgt siden, om du er logget ind og hvilket sprog og valuta, du gerne vil have vist på hjemmesiden. Vi bruger også cookies til at målrette vores annoncer over for dig på andre hjemmesider. Helt overordnet anvendes cookies således som del af vores service til at vise indhold, der er så relevant som muligt for dig.</p>
          
          <h4>7.3 Hvor længe opbevares cookies?</h4>
          <p>Det er varierende, hvor længe cookies opbevares på dit udstyr. Tiden regnes fra den seneste gang, du var inden på hjemmesiden. Efter udløb vil cookies automatisk blive slettet. Du kan se en fuldendt liste nedenfor.</p>
          
          <h4>7.4 Sådan afviser eller sletter du dine cookies</h4>
          <p>Du kan altid afvise cookies på din computer, tablet eller telefon ved at ændre indstillingerne i din browser. Hvor du finder indstillingerne afhænger af, hvilken browser du anvender. Du skal dog være opmærksom på, at hvis du gør det, er der mange funktioner og services, du ikke kan bruge, fordi de forudsætter, at hjemmesiden kan huske de valg, du foretager.</p>
          <p>Du kan fravælge cookies fra Google Analytics her.</p>
          
          <h4>7.5 Sletning af cookies</h4>
          <p>Cookies som du tidligere har accepteret, kan efterfølgende slettes nemt. Benytter du en PC med en nyere browser, kan du slette dine cookies ved at bruge genvejstasterne: CTRL + SHIFT + Delete.</p>
          <p>Virker genvejstasterne ikke, og/eller benytter du en MAC, skal du starte med at finde ud af, hvilken browser du bruger og herefter klikke på det relevante link:</p>
          <div class="browser-links">
            <a href="https://support.microsoft.com/da-dk/help/17442/windows-internet-explorer-delete-manage-cookies" target="_blank">Internet Explorer</a>
            <a href="https://support.mozilla.org/da/kb/slette-cookies" target="_blank">Mozilla Firefox</a>
            <a href="https://support.google.com/chrome/answer/95647" target="_blank">Google Chrome</a>
            <a href="https://help.opera.com/da/latest/web-preferences/#cookies" target="_blank">Opera</a>
            <a href="https://support.apple.com/da-dk/guide/safari/sfri11471/mac" target="_blank">Safari</a>
            <a href="https://helpx.adobe.com/flash-player/kb/disable-local-shared-objects-flash.html" target="_blank">Flash cookies</a>
            <a href="https://support.apple.com/da-dk/HT201265" target="_blank">Apple</a>
            <a href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DAndroid" target="_blank">Android</a>
            <a href="https://support.microsoft.com/da-dk/help/17442/windows-internet-explorer-delete-manage-cookies" target="_blank">Windows 7</a>
          </div>
          <p>Husk: Bruger du flere Internet-browsere, skal du slette cookies i dem alle.</p>
          
          <h4>7.6 Har du spørgsmål?</h4>
          <p>Har du kommentarer eller spørgsmål i forbindelse med vores information og/eller behandling af personlige oplysninger, er du velkommen til at kontakte os. Selve cookiedeklarationen bliver opdateret hver måned af Cookie Information og hvis du har nogen spørgsmål til den, så kan du skrive til info@cookieinformation.com.</p>
        </div>
        
        <div v-if="activeTab === 'details'" class="tab-content">
          <div class="cookie-detail-item">
            <h4>Nødvendige</h4>
            <p>Nødvendige cookies hjælper med at gøre en hjemmeside brugbar ved at aktivere grundlæggende funktioner, såsom side-navigation og adgang til sikre områder af hjemmesiden. Hjemmesiden kan ikke fungere optimalt uden disse cookies.</p>
          </div>
          <div class="cookie-detail-item">
            <h4>Statistiske</h4>
            <p>Vi indsamler oplysninger om, hvordan du interagerer med hjemmesiden, herunder hvor ofte du besøger siden, og hvilke sider du kigger på. Det gør vi for at kunne optimere design, brugervenlighed og styrke effektiviteten af hjemmesiden. Derudover bruger vi oplysningerne til at give dig personaliseret indhold og udarbejde markedsanalyser.</p>
          </div>
          <div class="cookie-detail-item">
            <h4>Marketing</h4>
            <p>Vi indsamler oplysninger om dine interesser, herunder hvilke sider og annoncer du klikker på, hvilke produkter eller ydelser du viser interesse for, eller køber, på denne og andre hjemmesider. Det gør vi for at kunne vise dig annoncer, der er relevante for dig og dine interesser. For at kunne vise dig målrettede annoncer på denne og andre hjemmesider, samarbejder vi med andre virksomheder, som vi deler oplysninger med. Det kan du læse mere om herunder.</p>
          </div>
        </div>
      </div>
      
      <div class="cookie-actions">
        <button class="btn-reject" @click="rejectAll">Afvis alle</button>
        <button class="btn-accept" @click="acceptAll">Accepter alle</button>
      </div>
      
      <div class="cookie-types">
        <div class="cookie-type-item">
          <span>Nødvendige</span>
          <span class="toggle-wrapper">
            <span class="toggle" :class="{ active: cookiePreferences.necessary }" @click="toggleCookie('necessary')"></span>
          </span>
        </div>
        <div class="cookie-type-item">
          <span>Statistiske</span>
          <span class="toggle-wrapper">
            <span class="toggle" :class="{ active: cookiePreferences.statistics }" @click="toggleCookie('statistics')"></span>
          </span>
        </div>
        <div class="cookie-type-item">
          <span>Marketing</span>
          <span class="toggle-wrapper">
            <span class="toggle" :class="{ active: cookiePreferences.marketing }" @click="toggleCookie('marketing')"></span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CookieConsent',
  data() {
    return {
      showCookieModal: false,
      activeTab: '',
      cookiePreferences: {
        necessary: true,
        statistics: false,
        marketing: false
      }
    };
  },
  mounted() {
    this.checkCookieConsent();
  },
  methods: {
    checkCookieConsent() {
      const consent = localStorage.getItem('cookieConsent');
      if (!consent) {
        setTimeout(() => {
          //this.showCookieModal = true;
        }, 500);
      }
    },
    acceptAll() {
      this.cookiePreferences = {
        necessary: true,
        statistics: true,
        marketing: true
      };
      this.saveConsent();
      this.showCookieModal = false;
    },
    rejectAll() {
      this.cookiePreferences = {
        necessary: true,
        statistics: false,
        marketing: false
      };
      this.saveConsent();
      this.showCookieModal = false;
    },
    toggleCookie(type) {
      if (type !== 'necessary') {
        this.cookiePreferences[type] = !this.cookiePreferences[type];
      }
    },
    saveConsent() {
      localStorage.setItem('cookieConsent', JSON.stringify(this.cookiePreferences));
    },
    closeModal() {
      this.showCookieModal = false;
    }
  }
};
</script>

<style scoped>
.cookie-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  padding: 20px;
  box-sizing: border-box;
}

.cookie-modal {
  background: white;
  border-radius: 8px;
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.cookie-content {
  padding: 24px;
  overflow-y: auto;
  max-height: calc(90vh - 160px);
}

.cookie-content h2 {
  font-size: 22px;
  font-weight: 600;
  color: #333;
  margin: 0 0 16px 0;
}

.cookie-content p {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin: 0 0 16px 0;
}

.cookie-links {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 20px;
}

.cookie-links a {
  font-size: 14px;
  color: #066AAF;
  text-decoration: underline;
  cursor: pointer;
}

.cookie-links a:hover {
  color: #077CCD;
}

.tab-content {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #eee;
}

.tab-content h3 {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0 0 12px 0;
}

.tab-content h4 {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin: 16px 0 8px 0;
}

.tab-content p {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin: 0 0 10px 0;
}

.browser-links {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 15px;
}

.browser-links a {
  color: #066AAF;
  text-decoration: underline;
  font-size: 14px;
}

.cookie-detail-item {
  margin-bottom: 20px;
}

.cookie-detail-item:last-child {
  margin-bottom: 0;
}

.cookie-detail-item h4 {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
}

.cookie-detail-item p {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin: 0;
}

.cookie-actions {
  display: flex;
  gap: 12px;
  padding: 16px 24px;
  background: #f8f8f8;
  border-top: 1px solid #eee;
}

.cookie-actions button {
  flex: 1;
  height: 44px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.2s;
}

.cookie-actions button:hover {
  opacity: 0.9;
}

.btn-reject {
  background: #ccc;
  color: #333;
}

.btn-accept {
  background: #0a7428;
  color: white;
}

.cookie-types {
  display: flex;
  justify-content: space-around;
  padding: 16px 24px;
  background: #e8e8e8;
  border-top: 1px solid #ddd;
  border-radius: 0 0 8px 8px;
}

.cookie-type-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.cookie-type-item span:first-child {
  font-size: 12px;
  color: #666;
  font-weight: 500;
}

.toggle-wrapper {
  display: inline-block;
}

.toggle {
  display: inline-block;
  width: 48px;
  height: 28px;
  background: #999;
  border-radius: 14px;
  position: relative;
  cursor: pointer;
  transition: background 0.3s;
}

.toggle::before {
  content: '';
  position: absolute;
  top: 4px;
  left: 4px;
  width: 20px;
  height: 20px;
  background: white;
  border-radius: 50%;
  transition: transform 0.3s;
}

.toggle.active {
  background: #0a7428;
}

.toggle.active::before {
  transform: translateX(20px);
}

@media (max-width: 768px) {
  .cookie-content {
    padding: 16px;
  }
  
  .cookie-content h2 {
    font-size: 18px;
  }
  
  .cookie-actions {
    padding: 12px 16px;
  }
  
  .cookie-actions button {
    height: 40px;
    font-size: 14px;
  }
  
  .cookie-types {
    padding: 12px 16px;
  }
  
  .cookie-type-item span:first-child {
    font-size: 11px;
  }
}
</style>